import VerticalLayout from "./VerticalLayout";

export { VerticalLayout };
